import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { AIAssistantStore } from './store';
import type { AIAssistantMode } from './types';
import { AIAssistantContext } from './useAIAssistantContext';

export interface AIAssistantContextProviderProps {
	children: ReactNode;
	mode: AIAssistantMode;
	id: string;
}

export function AIAssistantProvider({
	children,
	mode,
	id,
}: AIAssistantContextProviderProps) {
	const [store] = useState(() => new AIAssistantStore(mode));

	useEffect(() => {
		// updated the store whenever id changes
		store.setId(id);
	}, [id, store]);

	return (
		<AIAssistantContext.Provider value={store}>
			{children}
		</AIAssistantContext.Provider>
	);
}
